// extracted by mini-css-extract-plugin
export default {"CountriesFeature":"wb_a bhr_b"};